import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GettGritRankQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Grit_Bool_Exp>;
}>;


export type GettGritRankQuery = { __typename?: 'query_root', grit: Array<{ __typename?: 'grit', score?: any | null, user?: { __typename?: 'users', id: string, createdAt?: any | null, fullName?: string | null, mentorEnabled?: boolean | null, menteeEnabled?: boolean | null, profession?: string | null, profilePhotoLink?: string | null, specialtyId?: any | null, role?: { __typename?: 'roles', name: string } | null, workspaceLocation?: { __typename?: 'workspaceLocations', abbreviation?: string | null, id: number } | null, mentorshipsAsMentor: Array<{ __typename?: 'mentorship', id: any, mentorshipProgram?: { __typename?: 'mentorshipProgram', id: number, name: string } | null }>, mentorshipsAsMentee: Array<{ __typename?: 'mentorship', id: any, mentorshipProgram?: { __typename?: 'mentorshipProgram', id: number, name: string } | null }> } | null, specialty?: { __typename?: 'specialties', id: any, name: string } | null }> };


export const GettGritRankDocument = gql`
    query gettGRITRank($where: grit_bool_exp) {
  grit(where: $where, order_by: {score: desc}) {
    user {
      id
      createdAt
      fullName
      mentorEnabled
      menteeEnabled
      role {
        name
      }
      profession
      workspaceLocation {
        abbreviation
        id
      }
      profilePhotoLink
      specialtyId
      mentorshipsAsMentor {
        id
        mentorshipProgram {
          id
          name
        }
      }
      mentorshipsAsMentee {
        id
        mentorshipProgram {
          id
          name
        }
      }
    }
    specialty {
      id
      name
    }
    score
  }
}
    `;

/**
 * __useGettGritRankQuery__
 *
 * To run a query within a React component, call `useGettGritRankQuery` and pass it any options that fit your needs.
 * When your component renders, `useGettGritRankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGettGritRankQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGettGritRankQuery(baseOptions?: Apollo.QueryHookOptions<GettGritRankQuery, GettGritRankQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GettGritRankQuery, GettGritRankQueryVariables>(GettGritRankDocument, options);
      }
export function useGettGritRankLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GettGritRankQuery, GettGritRankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GettGritRankQuery, GettGritRankQueryVariables>(GettGritRankDocument, options);
        }
export function useGettGritRankSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GettGritRankQuery, GettGritRankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GettGritRankQuery, GettGritRankQueryVariables>(GettGritRankDocument, options);
        }
export type GettGritRankQueryHookResult = ReturnType<typeof useGettGritRankQuery>;
export type GettGritRankLazyQueryHookResult = ReturnType<typeof useGettGritRankLazyQuery>;
export type GettGritRankSuspenseQueryHookResult = ReturnType<typeof useGettGritRankSuspenseQuery>;
export type GettGritRankQueryResult = Apollo.QueryResult<GettGritRankQuery, GettGritRankQueryVariables>;